import React from 'react';
import { useTranslation } from 'react-i18next';
import Seo from '../components/Seo.js';

const TermsOfUse = () => {
  const { t } = useTranslation();

  return (
    <main className="container mx-auto px-4 py-8">
      <Seo path="/terms-of-use" title={t('termsOfUse.seo.title')} description={t('termsOfUse.seo.description')} />
      <article>
        <h1 className="text-3xl font-bold mb-4">{t('termsOfUse.title')}</h1>
        <p className="mb-4">
          {t('termsOfUse.intro')}
        </p>
        <section>
          <h2 className="text-2xl font-bold mb-2">{t('termsOfUse.section1.title')}</h2>
          <p className="mb-4">
            {t('termsOfUse.section1.description')}
          </p>
          <ul className="list-disc list-inside mb-4">
            <li>{t('termsOfUse.section1.item1')}</li>
            <li>{t('termsOfUse.section1.item2')}</li>
            <li>{t('termsOfUse.section1.item3')}</li>
            <li>{t('termsOfUse.section1.item4')}</li>
            <li>{t('termsOfUse.section1.item5')}</li>
          </ul>
        </section>
        <section>
          <h2 className="text-2xl font-bold mb-2">{t('termsOfUse.section2.title')}</h2>
          <p className="mb-4">
            {t('termsOfUse.section2.content')}
          </p>
        </section>
        <section>
          <h2 className="text-2xl font-bold mb-2">{t('termsOfUse.section3.title')}</h2>
          <p className="mb-4">
            {t('termsOfUse.section3.content')}
          </p>
        </section>
        <section>
          <h2 className="text-2xl font-bold mb-2">{t('termsOfUse.section4.title')}</h2>
          <p className="mb-4">
            {t('termsOfUse.section4.content')}
          </p>
        </section>
        <p>
          {t('termsOfUse.effectiveDate')}
        </p>
      </article>
    </main>
  );
};

export default TermsOfUse;
